//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from 'jquery'
import png from '../assets/img/HappyBirthday.png'

export default {
  components: {

  },
  data () {
    return {
      msg: 'Hello World!',
      png_url: png
    }
  },
  methods: {
    btnclick () {
      $('#ILove').remove()
      $('#isLike').append(`<div class="lk1" id="ILove" style=" opacity:0;font-size:10px;color:yellow;" >算你有眼光哈！</div>`)
      $('#ILove').animate({
        opacity: '1',
        fontSize: '30px'
      }, 300)
      setTimeout(this.jump, 3000)
    },
    jump () {
      $('audio#cake-music')[0].pause()
      $('audio#img-music')[0].play()
      let url = '/img'
      this.$router.push({ path: url })
    }
  },
  mounted () {
    setTimeout(function () {
      $('.name').animate({
        opacity: '1',
        top: '15%'
      }, 2000)
    }, 6000)
    setTimeout(function () {
      $('.happy').animate({
        opacity: '1',
        top: '15%'
      }, 2000)
    }, 6000)
    setTimeout(function () {
      $('.button-style1:not(#isLike)').animate({
        opacity: '1',
        top: '80%'
      }, 1500)
    }, 9000)
    setTimeout(function () {
      $('#isLike').animate({
        opacity: '1',
        top: '60%'
      }, 1500)
    }, 7000)
  }
}



// WEBPACK FOOTER //
// ./src/components/Cake.vue